var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash',{attrs:{"icon":"fa fa-users","titulo":"TOTAL DE ACESSOS NO MÊS","qtd":_vm.qtd,"loading":_vm.loading,"color":"#4DA2F8"}})
}
var staticRenderFns = []

export { render, staticRenderFns }